import { BaseDto } from "@/shared/dtos/base-dto";

export class connectDto extends BaseDto {
    public servidor!:string;
    public base_de_datos!:string;
    public usuario!:string;
    public contrasena!:string;
    public contrasena_verificacion!:string;
}
